<!-- cv简历信息表-活动组件级 -->
<template>
  <div class='detail-wrap'>
    <div class='detail-container'>
      <div class='cv-detail cn'
           v-if='!isEditCn && lang==="cn"'>
        <div v-if='activityDetailCn.active && activityDetailCn.active.length > 0'>
          <ul v-for='(item, index) in activityDetailCn.active'
              :key='index'>
            <li>
              <span class='cv-detail-name'>活动类型：</span>
              <span class='cv-detail-val'>{{item.type && new Map(activityTypeCnMap).get(item.type)}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>活动名称：</span>
              <span class='cv-detail-val'>{{item.name}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>领导力：</span>
              <span class='cv-detail-val'>{{item.leadership && new Map(leadershipCnMap).get(item.leadership)}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>参与日期：</span>
              <span class='cv-detail-val'>{{item.joinTime && item.joinTime[0] && item.joinTime[1] && `${item.joinTime[0]} 至 ${item.joinTime[1]}`}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>参与时段：</span>
              <!-- <span class='cv-detail-val'>{{item.timeFrame && new Map(timeFrameCnMap).get(item.timeFrame)}}</span> -->
              <span class='cv-detail-val'
                    v-if='item.timeFrame && item.timeFrame.length > 0'><span v-for='(time, idx) in item.timeFrame'
                      :key='idx'>{{new Map(timeFrameCnMap).get(time)}}<span v-if='idx !== item.timeFrame.length - 1'>,&nbsp;&nbsp;</span></span></span>
            </li>
            <li>
              <span class='cv-detail-name'>年级：</span>
              <!-- <span class='cv-detail-val'>{{item.gradeLevel && new Map(gradeCnMap).get(item.gradeLevel)}}</span> -->
              <span class='cv-detail-val'
                    v-if='item.gradeLevel && item.gradeLevel.length > 0'><span v-for='(time, idx) in item.gradeLevel'
                      :key='idx'>{{new Map(gradeCnMap).get(time)}}<span v-if='idx !== item.gradeLevel.length - 1'>,&nbsp;&nbsp;</span></span></span>
            </li>
            <li>
              <span class='cv-detail-name'>每年活动周数：</span>
              <span class='cv-detail-val'>{{item.weeksPerYear}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>每周活动时长：</span>
              <span class='cv-detail-val'>{{item.hoursPerWeek}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>组织单位：</span>
              <span class='cv-detail-val'>{{item.heldBy}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>有意继续：</span>
              <span class='cv-detail-val'>{{item.keepIntend && new Map(isContinueCnMap).get(item.keepIntend.toString())}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>其他信息：</span>
              <span class='cv-detail-val'>{{item.notes}}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class='cv-detail en'
           v-if='!isEditEn && lang==="en"'>
        <div v-if='activityDetailEn.active && activityDetailEn.active.length > 0'>
          <ul v-for='(item, index) in activityDetailEn.active'
              :key='index'>
            <li>
              <span class='cv-detail-name'>Activity Type：</span>
              <span class='cv-detail-val'>{{item.type && new Map(activityTypeEnMap).get(item.type)}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>Activity Name：</span>
              <span class='cv-detail-val'>{{item.name}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>Leadership：</span>
              <span class='cv-detail-val'>{{item.leadership && new Map(leadershipEnMap).get(item.leadership)}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>Time of Activity：</span>
              <span class='cv-detail-val'>{{item.joinTime && item.joinTime[0] && item.joinTime[1] && `${item.joinTime[0]} to ${item.joinTime[1]}`}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>Timing of Participation：</span>
              <!-- <span class='cv-detail-val'>{{item.timeFrame && new Map(timeFrameEnMap).get(item.timeFrame)}}</span> -->
              <span class='cv-detail-val'
                    v-if='item.timeFrame && item.timeFrame.length > 0'><span v-for='(time, idx) in item.timeFrame'
                      :key='idx'>{{new Map(timeFrameEnMap).get(time)}}<span v-if='idx !== item.timeFrame.length - 1'>,&nbsp;&nbsp;</span></span></span>
            </li>
            <li>
              <span class='cv-detail-name'>Grade Level：</span>
              <!-- <span class='cv-detail-val'>{{item.gradeLevel && new Map(gradeEnMap).get(item.gradeLevel)}}</span> -->
              <span class='cv-detail-val'
                    v-if='item.gradeLevel && item.gradeLevel.length > 0'><span v-for='(grade, idx) in item.gradeLevel'
                      :key='idx'>{{new Map(gradeEnMap).get(grade)}}<span v-if='idx !== item.gradeLevel.length - 1'>,&nbsp;&nbsp;</span></span></span>
            </li>
            <li>
              <span class='cv-detail-name'>Weeks per Year：</span>
              <span class='cv-detail-val'>{{item.weeksPerYear}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>Hours per Week：</span>
              <span class='cv-detail-val'>{{item.hoursPerWeek}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>Held by：</span>
              <span class='cv-detail-val'>{{item.heldBy}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>Intend to Continue：</span>
              <span class='cv-detail-val'>{{item.keepIntend && new Map(isContinueEnMap).get(item.keepIntend)}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>Details, Honors and Accomplishments：</span>
              <span class='cv-detail-val'>{{item.notes}}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class='cv-form cn'
           v-if='isEditCn && lang==="cn"'>
        <Form ref="formValidateCn"
              :model="formValidateCn"
              :rules="ruleValidateCn"
              :label-width="300">

          <div class="base-form-wrap"
               v-if='formValidateCn.active && formValidateCn.active.length > 0'>
            <div class="base-form-item"
                 v-for='(item, index) in formValidateCn.active'
                 :key='index'>
              <FormItem label="活动类型："
                        :prop="`active.${index}.type`"
                        :rules="[{required: true, message: '请选择活动类型'}]">
                <Select v-model="item.type"
                        placeholder="请选择活动类型"
                        clearable>
                  <Option v-for='single in activityTypeCnMap'
                          :key='single[0]'
                          :value='single[0]'>{{single[1]}}
                  </Option>
                </Select>
              </FormItem>
              <FormItem label="活动名称："
                        :prop="`active.${index}.name`"
                        :rules="[{required: true, message: '请输入活动名称'}]">
                <Input v-model="item.name"
                       placeholder="格式为：XX平台/机构的XX职位"
                       clearable></Input>
              </FormItem>
              <FormItem label="领导力："
                        :prop="`active.${index}.leadership`"
                        :rules="[{required: true, message: '请选择领导力'}]">
                <Select v-model="item.leadership"
                        placeholder="请选择"
                        clearable>
                  <Option v-for='(single, idx) in leadershipCnMap'
                          :value='single[0]'
                          :key='idx'>{{single[1]}}
                  </Option>
                </Select>
              </FormItem>

              <FormItem label="参与日期："
                        :prop="`active.${index}.joinTime`">
                <date-picker-wrapper v-model="item.joinTime"
                                     type="monthrange"
                                     format='yyyy-MM'
                                     placeholder="请选择"></date-picker-wrapper>
              </FormItem>

              <FormItem label="参与时段："
                        :prop="`active.${index}.timeFrame`"
                        :rules="[{required: true, message: '请选择'}]">
                <CheckboxGroup v-model="item.timeFrame">
                  <Checkbox v-for="time in timeFrameCnMap"
                            :label="time[0]"
                            :value="time[0]"
                            :key="time[0]">{{time[1]}}
                  </Checkbox>
                </CheckboxGroup>
              </FormItem>
              <FormItem label="年级："
                        :prop="`active.${index}.gradeLevel`"
                        :rules="[{required: true, message: '请选择'}]">
                <CheckboxGroup v-model="item.gradeLevel">
                  <Checkbox v-for="grade in gradeCnMap"
                            :label="grade[0]"
                            :value="grade[0]"
                            :key="grade[0]">{{grade[1]}}
                  </Checkbox>
                </CheckboxGroup>
              </FormItem>
              <FormItem label="每年活动周数："
                        :prop="`active.${index}.weeksPerYear`"
                        :rules="[{required: true, message: '请输入平均每年参加活动的周数'},
                                {pattern: /(^\d+$)|(^\d+\.\d)$/, message: '请输入平均每年参加活动的周数'}
                        ]">
                <Input v-model="item.weeksPerYear"
                       placeholder="请输入平均每年参加活动的周数"
                       clearable></Input>
              </FormItem>
              <FormItem label="每周活动时长："
                        :prop="`active.${index}.hoursPerWeek`"
                        :rules="[{required: true, message: '请输入平均每周参加活动的小时数'},
                                {pattern: /(^\d+$)|(^\d+\.\d)$/, message: '请输入平均每周参加活动的小时数'}
                        ]">
                <Input v-model="item.hoursPerWeek"
                       placeholder="请输入平均每周参加活动的小时数"
                       clearable></Input>
              </FormItem>
              <FormItem label="组织单位："
                        :prop="`active.${index}.heldBy`"
                        :rules="[{required: true, message: '请输入活动的组织单位'}]">
                <Input v-model="item.heldBy"
                       placeholder="请输入活动的组织单位"
                       clearable></Input>
              </FormItem>
              <FormItem label="有意继续："
                        :prop="`active.${index}.keepIntend`"
                        :rules="[{required: true, message: '请选择'}]">
                <Select v-model="item.keepIntend"
                        placeholder="请选择大学期间是否有意继续类似活动？"
                        clearable>
                  <Option v-for="(single, idx) in isContinueCnMap"
                          :value="single[0]"
                          :key="idx">{{single[1]}}
                  </Option>
                </Select>
              </FormItem>
              <FormItem label="其他信息："
                        :prop="`active.${index}.notes`"
                        :rules="[{required: true, message: '请输入其他信息'}]">
                <Input type='textarea'
                       :rows='5'
                       v-model="item.notes"
                       placeholder="简单介绍活动具体细节，如活动，奖项，收获，结果和影响（对他人或者自己）"></Input>
              </FormItem>
              <div class='oper-del'>
                <a href='javascript: void(0)'
                   @click="delCn(item, index)">删除</a>
              </div>
            </div>
          </div>
          <div class='oper-add'>
            <a href='javascript: void(0)'
               @click="addCn">添加</a>
          </div>
          <div class="sub-btn">
            <Button type='primary'
                    :loading='hasSaveCn'
                    @click="saveCn">保存
            </Button>
            <!-- <a href='javascript: void(0)'
               @click="saveCn">保存</a> -->
          </div>
        </Form>
      </div>
      <div class='cv-form en'
           v-if='isEditEn && lang==="en"'>
        <Form ref="formValidateEn"
              :model="formValidateEn"
              :rules="ruleValidateEn"
              :label-width="300">

          <div class="base-form-wrap"
               v-if='formValidateEn.active && formValidateEn.active.length > 0'>
            <div class="base-form-item"
                 v-for='(item, index) in formValidateEn.active'
                 :key='index'>
              <FormItem label="Activity Type："
                        :prop="`active.${index}.type`"
                        :rules="[{required: true, message: 'Please select'}]">
                <Select v-model="item.type"
                        placeholder="Please select"
                        clearable>
                  <Option v-for='single in activityTypeEnMap'
                          :key='single[0]'
                          :value='single[0]'>{{single[1]}}
                  </Option>
                </Select>
              </FormItem>
              <FormItem label="Activity Name："
                        :prop="`active.${index}.name`"
                        :rules="[{required: true, message: 'Please enter activity name'}]">
                <Input v-model="item.name"
                       placeholder="(Job title) at (company/organization’s name)"
                       clearable></Input>
              </FormItem>
              <FormItem label="Leadership："
                        :prop="`active.${index}.leadership`"
                        :rules="[{required: true, message: 'Please select'}]">
                <Select v-model="item.leadership"
                        placeholder="Were you a leader in this activity ? Choose an item"
                        clearable>
                  <Option v-for='(single, idx) in leadershipEnMap'
                          :value='single[0]'
                          :key='idx'>{{single[1]}}
                  </Option>
                </Select>
              </FormItem>
              <FormItem label="Time of activity："
                        :prop="`active.${index}.joinTime`">
                <date-picker-wrapper v-model="item.joinTime"
                                     type="monthrange"
                                     format='yyyy-MM'
                                     placeholder="Please select"></date-picker-wrapper>
              </FormItem>
              <FormItem label="Timing of Participation："
                        :prop="`active.${index}.timeFrame`"
                        :rules="[{required: true, message: 'Please select'}]">
                <CheckboxGroup v-model="item.timeFrame">
                  <Checkbox v-for="time in timeFrameEnMap"
                            :label="time[0]"
                            :value="time[0]"
                            :key="time[0]">{{time[1]}}
                  </Checkbox>
                </CheckboxGroup>
              </FormItem>
              <FormItem label="Grade Level："
                        :prop="`active.${index}.gradeLevel`"
                        :rules="[{required: true, message: 'Please select'}]">
                <CheckboxGroup v-model="item.gradeLevel">
                  <Checkbox v-for="time in gradeEnMap"
                            :label="time[0]"
                            :value="time[0]"
                            :key="time[0]">{{time[1]}}
                  </Checkbox>
                </CheckboxGroup>
              </FormItem>
              <FormItem label="Weeks per Year："
                        :prop="`active.${index}.weeksPerYear`"
                        :rules="[{required: true, message: 'please enter average weeks spent doing this activity per year'},
                                {pattern: /(^\d+$)|(^\d+\.\d)$/, message: 'please enter average weeks spent doing this activity per year'}
                        ]">
                <Input v-model="item.weeksPerYear"
                       placeholder="please enter average weeks spent doing this activity per year"
                       clearable></Input>
              </FormItem>
              <FormItem label="Hours per Week："
                        :prop="`active.${index}.hoursPerWeek`"
                        :rules="[{required: true, message: 'please enter average hours spent doing this activity per week'},
                                {pattern: /(^\d+$)|(^\d+\.\d)$/, message: 'please enter average hours spent doing this activity per week'}
                        ]">
                <Input v-model="item.hoursPerWeek"
                       placeholder="please enter average hours spent doing this activity per week"
                       clearable></Input>
              </FormItem>
              <FormItem label="Held by："
                        :prop="`active.${index}.heldBy`"
                        :rules="[{required: true, message: 'Please enter name of the company/organization'}]">
                <Input v-model="item.heldBy"
                       placeholder="Name of the company/organization"
                       clearable></Input>
              </FormItem>
              <FormItem label="Intend to Continue："
                        :prop="`active.${index}.keepIntend`"
                        :rules="[{required: true, message: 'Please select'}]">
                <Select v-model="item.keepIntend"
                        placeholder="please select if you would like to continue doing this activity in college"
                        clearable>
                  <Option v-for="(single, idx) in isContinueEnMap"
                          :value="single[0]"
                          :key="idx">{{single[1]}}
                  </Option>
                </Select>
              </FormItem>
              <FormItem label="Details, Honors and Accomplishments*："
                        :prop="`active.${index}.notes`"
                        :rules="[{required: true, message: 'Please enter details, honors and accomplishments*'}]">
                <Input type='textarea'
                       :rows='5'
                       v-model="item.notes"
                       placeholder="Briefly describe the experience (how it affected you and others)."></Input>
              </FormItem>
              <div class='oper-del'>
                <a href='javascript: void(0)'
                   @click="delEn(item, index)">Delete</a>
              </div>
            </div>
          </div>
          <div class='oper-add'>
            <a href='javascript: void(0)'
               @click="addEn">Add</a>
          </div>
          <div class="sub-btn">
            <Button type='primary'
                    :loading='hasSaveEn'
                    @click="saveEn">Save
            </Button>
          </div>
        </Form>
      </div>
      <div class='cv-btn cn'
           v-if='lang==="cn"'>
        <a href='javascript: void(0)'
           @click="goEditCn">{{isEditCn ? '返回' : '编辑'}}</a>
      </div>
      <div class='cv-btn en'
           v-if='lang==="en"'>
        <a href='javascript: void(0)'
           @click="goEditEn">{{isEditEn ? 'back' : 'Edit'}}</a>
      </div>
    </div>
  </div>
</template>

<script>
import cvService from '@/api/undergraduate/cv'
import {
  activityTypeCnMap,
  activityTypeEnMap,
  gradeCnMap,
  gradeEnMap,
  isContinueCnMap,
  isContinueEnMap,
  leadershipCnMap,
  leadershipEnMap,
  timeFrameCnMap,
  timeFrameEnMap
} from '../constants'
import './cv-detail.less'
import DatePickerWrapper from '@/components/date/DatePickerWrapper'

export default {
  name: '',
  props: {
    lang: {
      type: String,
      default: ''
    }
  },
  components: { DatePickerWrapper },
  data () {
    return {
      // 活动类型映射
      activityTypeCnMap,
      activityTypeEnMap,
      // 领导力映射
      leadershipCnMap,
      leadershipEnMap,
      // 参与时段映射
      timeFrameCnMap,
      timeFrameEnMap,
      // 年级映射
      gradeCnMap,
      gradeEnMap,
      // 有意继续映射
      isContinueCnMap,
      isContinueEnMap,
      // 是否编辑状态标识
      isEditEn: false,
      isEditCn: false,
      // 获取活动详情
      activityDetailCn: {},
      activityDetailEn: {},
      // Cn表单
      formValidateCn: {
        active: [
          // {
          //   type: '',
          //   name: '',
          //   leadership: '',
          //   joinTime: ['', ''],
          //   joinStartTime: '',
          //   joinEndTime: '',
          //   timeFrame: '',
          //   gradeLevel: '',
          //   weeksPerYear: '',
          //   hoursPerWeek: '',
          //   heldBy: '',
          //   keepIntend: '',
          //   notes: ''
          // }
        ]
      },
      ruleValidateCn: {},
      // En表单
      formValidateEn: {
        active: [
          // {
          //   type: '',
          //   name: '',
          //   leadership: '',
          //   joinTime: ['', ''],
          //   joinStartTime: '',
          //   joinEndTime: '',
          //   timeFrame: '',
          //   gradeLevel: '',
          //   weeksPerYear: '',
          //   hoursPerWeek: '',
          //   heldBy: '',
          //   keepIntend: '',
          //   notes: ''
          // }
        ]
      },
      ruleValidateEn: {},
      // loading-表单提交-避免重复提交
      hasSaveCn: false,
      hasSaveEn: false
    }
  },
  computed: {},
  mounted () {
    this.$nextTick(() => {
      if (this.lang === 'cn') {
        this.getActivityDetailCn()
      }
      if (this.lang === 'en') {
        this.getActivityDetailEn()
      }
    })
  },
  methods: {
    // 获取活动-cn
    getActivityDetailCn () {
      cvService.cvActivityDetailCn().then(res => {
        let data = res.data.model
        let temp = res.data.model
        // 处理时间-有些粗糙
        if (temp) {
          if (temp.active && temp.active.length > 0) {
            temp.active.map((item, index) => {
              data.active[index].leadership = (item.leadership || String(item.leadership) === 'false') ? String(item.leadership) : ''
              data.active[index].keepIntend = (item.keepIntend || String(item.keepIntend) === 'false') ? String(item.keepIntend) : ''
              data.active[index].joinTime = [item.joinStartTime, item.joinEndTime]
              return item
            })
          }
          this.activityDetailCn = data
          this.formValidateCn = data
        }
      }).catch(error => {
        this.$ugd_message(error.message, 'error')
      })
    },
    // 获取活动-en
    getActivityDetailEn () {
      cvService.cvActivityDetailEn().then(res => {
        let data = res.data.model
        let temp = res.data.model
        // 处理时间-有些粗糙
        if (temp) {
          if (temp.active && temp.active.length > 0) {
            temp.active.map((item, index) => {
              data.active[index].leadership = (item.leadership || String(item.leadership) === 'false') ? String(item.leadership) : ''
              data.active[index].keepIntend = (item.keepIntend || String(item.keepIntend) === 'false') ? String(item.keepIntend) : ''
              data.active[index].joinTime = [item.joinStartTime, item.joinEndTime]
              return item
            })
          }
          this.activityDetailEn = data
          this.formValidateEn = data
        }
      }).catch(error => {
        this.$ugd_message(error.message, 'error')
      })
    },
    // 编辑-返回
    goEditCn () {
      this.isEditCn = !this.isEditCn
      this.getActivityDetailCn()
    },
    // edit-back
    goEditEn () {
      this.isEditEn = !this.isEditEn
      this.getActivityDetailEn()
    },
    // 删除
    delCn (item, index) {
      this.formValidateCn.active.splice(index, 1)
    },
    // Delete
    delEn (item, index) {
      this.formValidateEn.active.splice(index, 1)
    },
    // 添加
    addCn () {
      this.formValidateCn.active.push(
        {
          type: '',
          name: '',
          leadership: '',
          joinTime: ['', ''],
          joinStartTime: '',
          joinEndTime: '',
          timeFrame: [],
          gradeLevel: [],
          weeksPerYear: '',
          hoursPerWeek: '',
          heldBy: '',
          keepIntend: '',
          notes: ''
        }
      )
    },
    // Add
    addEn () {
      this.formValidateEn.active.push(
        {
          type: '',
          name: '',
          leadership: '',
          joinTime: ['', ''],
          joinStartTime: '',
          joinEndTime: '',
          timeFrame: [],
          gradeLevel: [],
          weeksPerYear: '',
          hoursPerWeek: '',
          heldBy: '',
          keepIntend: '',
          notes: ''
        }
      )
    },
    // // onChange事件
    // changeJoinTimeCn (time, idx) {
    //   if (time[0] !== '') {
    //     this.formValidateCn.active[idx].joinStartTime = dayjs(time[0]).format('YYYY-MM')
    //     this.formValidateCn.active[idx].joinEndTime = dayjs(time[1]).format('YYYY-MM')
    //   }
    // },
    // // onChange事件
    // changeJoinTimeEn (time, idx) {
    //   if (time[0] !== '') {
    //     this.formValidateEn.active[idx].joinStartTime = dayjs(time[0]).format('YYYY-MM')
    //     this.formValidateEn.active[idx].joinEndTime = dayjs(time[1]).format('YYYY-MM')
    //   }
    // },
    // 保存
    saveCn () {
      if (this.formValidateCn.active && this.formValidateCn.active.length === 0) {
        this.hasSaveCn = true
        cvService.cvSaveActivityCn(this.formValidateCn).then(res => {
          this.hasSaveCn = false
          this.isEditCn = false
          this.$ugd_message('保存成功', 'success')
          this.getActivityDetailCn()
          // 调用详情接口
        }).catch(error => {
          this.hasSaveCn = false
          this.$ugd_message(error.message, 'error')
        })
        return
      }
      this.$refs.formValidateCn.validate((valid) => {
        if (valid) {
          // 时间段校验必填
          if (this.formValidateCn.active.findIndex(item => item.joinTime[0] === '') !== -1) {
            this.$ugd_message('请输入参与日期', 'error')
            return
          }
          this.hasSaveCn = true
          // 调用接口
          for (let i = 0; i < this.formValidateCn.active.length; i++) {
            this.formValidateCn.active[i].joinStartTime = this.formValidateCn.active[i].joinTime[0]
            this.formValidateCn.active[i].joinEndTime = this.formValidateCn.active[i].joinTime[1]
            delete this.formValidateCn.active[i].joinTime
          }
          cvService.cvSaveActivityCn(this.formValidateCn).then(res => {
            this.hasSaveCn = false
            this.isEditCn = false
            this.$ugd_message('保存成功', 'success')
            this.getActivityDetailCn()
            // 调用详情接口
          }).catch(error => {
            this.hasSaveCn = false
            this.$ugd_message(error.message, 'error')
          })
        }
      })
    },
    // Save
    saveEn () {
      if (this.formValidateEn.active && this.formValidateEn.active.length === 0) {
        this.hasSaveEn = true
        cvService.cvSaveActivityEn(this.formValidateEn).then(res => {
          this.hasSaveEn = false
          this.isEditEn = false
          this.$ugd_message('Save Success', 'success')
          this.getActivityDetailEn()
          // 调用详情接口
        }).catch(error => {
          this.hasSaveEn = false
          this.$ugd_message(error.message, 'error')
        })
        return
      }
      this.$refs.formValidateEn.validate((valid) => {
        if (valid) {
          // 时间段校验必填
          if (this.formValidateEn.active.findIndex(item => item.joinTime[0] === '') !== -1) {
            this.$ugd_message('Please select time of activity', 'error')
            return
          }
          this.hasSaveEn = true
          // 调用接口
          for (let i = 0; i < this.formValidateEn.active.length; i++) {
            this.formValidateEn.active[i].joinStartTime = this.formValidateEn.active[i].joinTime[0]
            this.formValidateEn.active[i].joinEndTime = this.formValidateEn.active[i].joinTime[1]
            delete this.formValidateEn.active[i].joinTime
          }
          cvService.cvSaveActivityEn(this.formValidateEn).then(res => {
            this.hasSaveEn = false
            this.isEditEn = false
            this.$ugd_message('Save Success', 'success')
            this.getActivityDetailEn()
            // 调用详情接口
          }).catch(error => {
            this.hasSaveEn = false
            this.$ugd_message(error.message, 'error')
          })
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
